import { ButtonSkeleton, CardSkeleton } from '@/components/shared/skeleton'

export const RentPassAutoSkeleton = () => (
  <div className="flex h-full flex-col justify-between pb-24">
    <div className="flex flex-col gap-16">
      <CardSkeleton className="h-[120px] w-full md:h-[96px] xxs:h-[60px]" />
      <CardSkeleton className="h-[188px] w-full md:h-[172px] xxs:h-[212px]" />
      <CardSkeleton className="h-[252px] w-full md:h-[268px] xxs:h-[292px]" />
    </div>
    <div>
      <hr className="mb-20 h-1 w-full text-grey-30" />
      <div className="flex items-center justify-between gap-12 xxs:flex-col xxs:items-stretch">
        <div className="flex flex-col gap-12 xxs:flex-row xxs:items-end xxs:justify-between">
          <ButtonSkeleton className="h-20 w-[130px] xxs:w-[100px]" />
          <ButtonSkeleton className="h-36 w-[188px] xxs:h-32 xxs:w-[120px]" />
        </div>
        <ButtonSkeleton className="h-[56px] w-[200px] xxs:w-full" />
      </div>
    </div>
  </div>
)
